// Shared constants, formatters and the amount input used across the P&L screen.
import React from "react";
import { Input } from "../components/ui/input";

export const SOURCE_LABELS = {
  ads: "Ads", organic: "Organic", commission_property: "Commission Property",
  commission_student_services: "Commission Student Services", not_set: "— Not set —",
  airbnb: "Airbnb", booking_com: "Booking.com", direct: "Direct", other_source: "Other",
};

export const TABS = [
  ["all", "All", null],
  ["mentorship", "Mentorship", ["ads", "organic"]],
  ["ads", "Ads", ["ads"]],
  ["organic", "Organic", ["organic"]],
  ["commission", "Commission", ["commission_property", "commission_student_services"]],
];

export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const COST_TYPES = ["operating", "luxury", "unclassified"];
export const COST_TYPE_LABELS = { operating: "Operating", luxury: "Luxury", unclassified: "Unclassified" };
export const COST_TYPE_STYLES = {
  operating: "border-brand-green/30 bg-brand-green/10 text-brand-green",
  luxury: "border-amber-400/30 bg-amber-400/10 text-amber-300",
  unclassified: "border-white/12 bg-white/[0.03] text-muted-foreground",
};

export const ALL_UNITS = "all";
export const MAIN_ID = "unit_main";
export const UNIT_KIND_LABELS = { business: "Business (£)", property: "Property (DH)" };

export const gbp = (n) => `£${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
export const mad = (n) => `${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })} DH`;
export const eur = (n) => `€${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
export const iso = (d) => d.toISOString().slice(0, 10);

// Format a numeric string with thousands separators, stripping leading zeros.
export const withCommas = (s) => {
  if (s === "" || s == null) return "";
  const [i, d] = String(s).split(".");
  const ii = (i.replace(/^0+(?=\d)/, "") || "0");
  const grouped = Number(ii).toLocaleString("en-US");
  return d !== undefined ? `${grouped}.${d}` : grouped;
};

// Comma-formatted numeric input that blocks leading zeros; commits a number on blur/Enter.
export function AmountInput({ value, onCommit, prefix, testId, className }) {
  const [text, setText] = React.useState(withCommas(value ?? ""));
  React.useEffect(() => { setText(value === "" || value == null ? "" : withCommas(String(value))); }, [value]);
  const handleChange = (e) => {
    const raw = e.target.value.replace(/[^\d.]/g, "");
    setText(withCommas(raw));
  };
  const commit = () => {
    const num = text === "" ? 0 : Number(text.replace(/,/g, "")) || 0;
    const incoming = value === "" || value == null ? 0 : Number(value) || 0;
    if (num !== incoming) onCommit(num);
  };
  return (
    <div className="flex items-center gap-1">
      {prefix && <span className="text-muted-foreground">{prefix}</span>}
      <Input value={text} onChange={handleChange} onBlur={commit} inputMode="decimal" data-testid={testId}
        onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }}
        className={className} />
    </div>
  );
}
